export default __webpack_public_path__ + "static/media/resume.70186842.svg";